import { createSlice } from '@reduxjs/toolkit'
import { IRestaurantDetailData } from 'interfaces/restaurant'
import { ITableEnableResponse } from 'interfaces/tab'
import { IFaqUrlResponse } from 'interfaces/common'

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState: {
    restuarantData: {},
    paymentEnableData: {},
    isPaymentStatusLoading: true,
    faqUrl: null as IFaqUrlResponse | null,
  },
  reducers: {
    setRestaurant: (state, action) => {
      state.restuarantData = action.payload
    },
    setIsPaymentEnable: (state, action) => {
      state.paymentEnableData = action.payload
      state.isPaymentStatusLoading = false
    },
    setPaymentStatusLoading: (state, action) => {
      state.isPaymentStatusLoading = action.payload
    },
    setFaqUrl: (state, action) => {
      state.faqUrl = action.payload
    },
  },
})

export const {
  setRestaurant,
  setIsPaymentEnable,
  setPaymentStatusLoading,
  setFaqUrl,
} = restaurantSlice.actions

export default restaurantSlice.reducer

export const restuarantData = (state: {
  restaurant: { restuarantData: IRestaurantDetailData }
}) => state.restaurant.restuarantData

export const paymentEnableData = (state: {
  restaurant: { paymentEnableData: ITableEnableResponse }
}) => state.restaurant.paymentEnableData

export const isPaymentStatusLoading = (state: {
  restaurant: { isPaymentStatusLoading: boolean }
}) => state.restaurant.isPaymentStatusLoading

export const faqUrlData = (state: {
  restaurant: { faqUrl: IFaqUrlResponse | null }
}) => state.restaurant.faqUrl
